<script setup lang="ts">
import FilterField from '@/components/atoms/element-filters/FilterField.vue'
import WorldFinder from '@/components/atoms/WorldFinder.vue'
import { appendWorld } from '@/appdata/world-filters'
import type { WorldInterface } from '@/types/worlds'

const sources = defineModel<WorldInterface[]>('sources', { default: () => [] })
defineProps<{ label?: string; placeholder?: string }>()

// Appends rather than replaces: the source filter is multi-select, so picking a second world
// widens the query instead of swapping which one it asks about. appendWorld makes a repeat pick a
// no-op — see @/appdata/world-filters.
const onWorldSelected = (event: any): void => {
  if (event?.item) sources.value = appendWorld(sources.value, event.item)
}
</script>

<template>
  <FilterField :label="label">
    <!-- Library-only: a source is where an element was published, so the user's own worlds and
         the ones they play in are left to the Campaign chip (WorldFilterControl).

         Always rendered. Hiding the finder once something was chosen is what made this
         single-select; with multiple selections allowed it has to stay reachable to add the next. -->
    <WorldFinder
      :library-only="true"
      :placeholder="placeholder"
      @world-selected="onWorldSelected"
    />
  </FilterField>
</template>
